// Get environment variable from runtime config (production) or Vite env (development)
// In production, env-config.js is injected at container startup
// In development, Vite provides the env vars via import.meta.env

type EnvKey = 'VITE_API_URL' | 'VITE_GOOGLE_CLIENT_ID';

declare global {
  interface Window {
    __ENV__?: {
      VITE_API_URL?: string;
      VITE_GOOGLE_CLIENT_ID?: string;
    };
  }
}

export function getEnv(key: EnvKey): string {
  // Check runtime config first (production)
  const runtimeValue = window.__ENV__?.[key];
  if (runtimeValue && !runtimeValue.startsWith('__')) {
    return runtimeValue;
  }

  // Fall back to Vite env (development)
  const viteValue = import.meta.env[key];
  if (viteValue) {
    return viteValue;
  }

  throw new Error(`${key} environment variable is required`);
}

export function getOptionalEnv(key: EnvKey): string | undefined {
  // Check runtime config first (production)
  const runtimeValue = window.__ENV__?.[key];
  if (runtimeValue && !runtimeValue.startsWith('__')) {
    return runtimeValue;
  }

  // Fall back to Vite env (development)
  const viteValue = import.meta.env[key];
  return viteValue || undefined;
}

export const API_URL = getEnv('VITE_API_URL');
export const GOOGLE_CLIENT_ID = getOptionalEnv('VITE_GOOGLE_CLIENT_ID');
